export const standardCompanyDescription = `
  <p>
    Private companies protect shareholders by limiting their personal legal liability, offering strong asset
    protection.
    They are also relatively simple to manage, which explains why private companies are the most common business
    structure in Australia.
  </p>

  <p>
    A full explanation of the available share classes can be found in the Share Allocation section of the form.
  </p>
`;

export const specialPurposeCompanyDescription = `
  <p>
    A special purpose SMSF trustee company is a company structure created to act as the trustee
    of a self-managed super fund. Our document package for this structure is divided into two parts.
  </p>

  <p>
    The first part provides detailed information to guide and educate trustees and members.
    The second part contains the company's legal constitution, which sets out its rules.
    This constitution includes provisions unique to SMSFs, such as options for determining voting power.
  </p>
`;
